const getDailyPricingData = priceData => {
  let memberPrice;
  let memberFee;
  let totalMemberPrice;
  let nonMemberPrice;
  let nonMemberFee;
  let totalNonMemberPrice;

  const { dropinPricingForRegistration = undefined, programPricingForRegistration = undefined } =
    priceData || {};

  if (dropinPricingForRegistration) {
    memberPrice = dropinPricingForRegistration?.memberBreakdown?.priceCents ?? null;
    memberFee = dropinPricingForRegistration?.memberBreakdown?.totalFeeCents ?? null;
    totalMemberPrice = dropinPricingForRegistration?.memberBreakdown?.totalChargeCents ?? null;
    nonMemberPrice = dropinPricingForRegistration?.nonmemberBreakdown?.priceCents ?? null;
    nonMemberFee = dropinPricingForRegistration?.nonmemberBreakdown?.totalFeeCents ?? null;
    totalNonMemberPrice =
      dropinPricingForRegistration?.nonmemberBreakdown?.totalChargeCents ?? null;
  }

  if (programPricingForRegistration) {
    const { pricingBreakdown } = programPricingForRegistration;
    memberPrice = pricingBreakdown?.memberPrice ?? null;
    nonMemberPrice = pricingBreakdown?.originalPrice ?? null;
  }

  return {
    memberPrice,
    memberFee,
    totalMemberPrice,
    nonMemberPrice,
    nonMemberFee,
    totalNonMemberPrice,
  };
};

export default getDailyPricingData;
